export type LonLat = {
  longitude: number;
  latitude: number;
};

export type WorldPoint = {
  x: number;
  y: number;
};

export const TILE_SIZE = 256;
export function clampLatitude(value: number) {
  return Math.min(Math.max(value, -85.05112878), 85.05112878);
}

export function normalizeLongitude(value: number) {
  let next = value;
  while (next < -180) next += 360;
  while (next > 180) next -= 360;
  return next;
}

function getScale(zoom: number) {
  return TILE_SIZE * (2 ** zoom);
}

export function lonLatToWorld(point: LonLat, zoom: number): WorldPoint {
  const scale = getScale(zoom);
  const normalizedLongitude = normalizeLongitude(point.longitude);
  const clampedLatitude = clampLatitude(point.latitude);
  const sinLatitude = Math.sin((clampedLatitude * Math.PI) / 180);
  return {
    x: ((normalizedLongitude + 180) / 360) * scale,
    y: (0.5 - (Math.log((1 + sinLatitude) / (1 - sinLatitude)) / (4 * Math.PI))) * scale,
  };
}

export function worldToLonLat(point: WorldPoint, zoom: number): LonLat {
  const scale = getScale(zoom);
  const longitude = normalizeLongitude((point.x / scale) * 360 - 180);
  const mercator = Math.PI - ((2 * Math.PI * point.y) / scale);
  const latitude = (180 / Math.PI) * Math.atan(0.5 * (Math.exp(mercator) - Math.exp(-mercator)));
  return {
    longitude,
    latitude: clampLatitude(latitude),
  };
}
